export default __webpack_public_path__ + "static/media/text-logo.5a7380fa.png";